 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"runtime": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Alldisease":"Alldisease","Choosetofocus":"Choosetofocus","Collection":"Collection","ColumnDetail":"ColumnDetail","ColumnList":"ColumnList","Connect":"Connect","Connect2":"Connect2","Detailsofdisease":"Detailsofdisease","Detdoctor":"Detdoctor","DrugDetail":"DrugDetail","Drugspeciespage":"Drugspeciespage","Editdisease":"Editdisease","Focus":"Focus","Getpersonalinfo":"Getpersonalinfo","Historicalrecord":"Historicalrecord","Home":"Home","Letters":"Letters","Livelist":"Livelist","MedicineBook":"MedicineBook","Modifydata":"Modifydata","Nopage":"Nopage","Organdetails":"Organdetails","Patientgroups":"Patientgroups","Registered":"Registered","Relatedtothedoctor":"Relatedtothedoctor","Screeningofsearch":"Screeningofsearch","Searchdrug":"Searchdrug","Searchlist":"Searchlist","Tem":"Tem","npm.crypto-js":"npm.crypto-js","npm.ali-oss":"npm.ali-oss","npm.qiniu-js":"npm.qiniu-js","CompleteInfo":"CompleteInfo","Userinfo":"Userinfo","npm.marked":"npm.marked","ArticleAiSummaryDetail":"ArticleAiSummaryDetail","Documentdetail":"Documentdetail","Search":"Search","npm.clipboard":"npm.clipboard","SearchMedSeek":"SearchMedSeek","npm.qrcodejs2":"npm.qrcodejs2","my":"my","npm.xgplayer-hls.js":"npm.xgplayer-hls.js","npm.xgplayer":"npm.xgplayer","Livedetail":"Livedetail","tabber":"tabber"}[chunkId]||chunkId) + "." + {"Alldisease":"c8c78606","Choosetofocus":"b5a38bdb","Collection":"687f7724","ColumnDetail":"0572f810","ColumnList":"69e1d24e","Connect":"e3554c35","Connect2":"caf45c8f","Detailsofdisease":"7a91d802","Detdoctor":"5a02796f","DrugDetail":"35770395","Drugspeciespage":"02f2f89e","Editdisease":"c28d332e","Focus":"4bc9cff4","Getpersonalinfo":"3f991d0d","Historicalrecord":"88f23a1d","Home":"0c10c637","Letters":"eb4fbb47","Livelist":"8847c509","MedicineBook":"004f1c6f","Modifydata":"d5271304","Nopage":"66e120ff","Organdetails":"816cc72f","Patientgroups":"292be148","Registered":"10f3e076","Relatedtothedoctor":"7bcbca6e","Screeningofsearch":"af971d63","Searchdrug":"55493130","Searchlist":"16b5f116","Tem":"d1d3ffac","chunk-00127e18":"511e0465","chunk-030d8c3a":"ea908149","chunk-17e8f758":"20ac90bf","chunk-2310fd30":"b994b933","chunk-2374f440":"d5dcddca","chunk-2a4da618":"5a2ab87f","chunk-2d20fb77":"1610ba8a","chunk-2d221c44":"93853ee3","chunk-2d5f0b0e":"03b24e0a","chunk-2d9aa5c2":"8f3dc4cf","chunk-36f69b42":"90bb52f5","chunk-37f3931c":"4d484aa9","chunk-49a19af8":"7ef4a5f4","chunk-523dc9f1":"572a8aa5","chunk-5381a0ee":"2ba0fe1c","chunk-5af20308":"0fed73ed","chunk-657a11f6":"683852b4","chunk-69311384":"d6956e8a","chunk-6dcce11d":"c46faa57","chunk-6fa1884a":"029a74b9","chunk-76c1fcf5":"8d413011","chunk-79a0dc60":"9d36ff93","chunk-7d5647b2":"3d39390a","chunk-8bf711ca":"2817a7de","chunk-98e8dae0":"df861097","chunk-c656edce":"7389137d","chunk-c8846038":"e40f7c8a","chunk-d58d70da":"81207743","chunk-fa6970fe":"26f9bec5","npm.crypto-js":"fb3973a2","npm.ali-oss":"1f7384e4","npm.qiniu-js":"dd3917eb","CompleteInfo":"1fa5f94e","Userinfo":"d497da39","chunk-282e9001":"59d4f482","npm.marked":"53657295","ArticleAiSummaryDetail":"7a65c4ea","chunk-341d270a":"7b51fad7","chunk-54e2d0d5":"db9e7a53","Documentdetail":"c8595abe","chunk-7a34045d":"103a48c7","Search":"35e93147","npm.clipboard":"392b9142","SearchMedSeek":"e746930f","npm.qrcodejs2":"870b7244","my":"e3d43896","npm.xgplayer-hls.js":"559c9495","npm.xgplayer":"2864d789","chunk-0fe15411":"2673447e","Livedetail":"30013c61","chunk-5c592e3c":"d778aa54","tabber":"ccf3c9b0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Alldisease":1,"Choosetofocus":1,"Collection":1,"ColumnDetail":1,"ColumnList":1,"Connect":1,"Connect2":1,"Detailsofdisease":1,"Detdoctor":1,"DrugDetail":1,"Drugspeciespage":1,"Editdisease":1,"Focus":1,"Getpersonalinfo":1,"Historicalrecord":1,"Home":1,"Letters":1,"Livelist":1,"MedicineBook":1,"Modifydata":1,"Nopage":1,"Organdetails":1,"Patientgroups":1,"Registered":1,"Relatedtothedoctor":1,"Screeningofsearch":1,"Searchdrug":1,"Searchlist":1,"Tem":1,"chunk-00127e18":1,"chunk-030d8c3a":1,"chunk-17e8f758":1,"chunk-2310fd30":1,"chunk-2374f440":1,"chunk-2a4da618":1,"chunk-2d5f0b0e":1,"chunk-2d9aa5c2":1,"chunk-36f69b42":1,"chunk-37f3931c":1,"chunk-49a19af8":1,"chunk-523dc9f1":1,"chunk-5381a0ee":1,"chunk-5af20308":1,"chunk-657a11f6":1,"chunk-69311384":1,"chunk-6dcce11d":1,"chunk-6fa1884a":1,"chunk-76c1fcf5":1,"chunk-79a0dc60":1,"chunk-7d5647b2":1,"chunk-8bf711ca":1,"chunk-98e8dae0":1,"chunk-c656edce":1,"chunk-c8846038":1,"chunk-d58d70da":1,"chunk-fa6970fe":1,"CompleteInfo":1,"Userinfo":1,"chunk-282e9001":1,"ArticleAiSummaryDetail":1,"chunk-341d270a":1,"chunk-54e2d0d5":1,"Documentdetail":1,"chunk-7a34045d":1,"Search":1,"SearchMedSeek":1,"my":1,"chunk-0fe15411":1,"Livedetail":1,"chunk-5c592e3c":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Alldisease":"Alldisease","Choosetofocus":"Choosetofocus","Collection":"Collection","ColumnDetail":"ColumnDetail","ColumnList":"ColumnList","Connect":"Connect","Connect2":"Connect2","Detailsofdisease":"Detailsofdisease","Detdoctor":"Detdoctor","DrugDetail":"DrugDetail","Drugspeciespage":"Drugspeciespage","Editdisease":"Editdisease","Focus":"Focus","Getpersonalinfo":"Getpersonalinfo","Historicalrecord":"Historicalrecord","Home":"Home","Letters":"Letters","Livelist":"Livelist","MedicineBook":"MedicineBook","Modifydata":"Modifydata","Nopage":"Nopage","Organdetails":"Organdetails","Patientgroups":"Patientgroups","Registered":"Registered","Relatedtothedoctor":"Relatedtothedoctor","Screeningofsearch":"Screeningofsearch","Searchdrug":"Searchdrug","Searchlist":"Searchlist","Tem":"Tem","npm.crypto-js":"npm.crypto-js","npm.ali-oss":"npm.ali-oss","npm.qiniu-js":"npm.qiniu-js","CompleteInfo":"CompleteInfo","Userinfo":"Userinfo","npm.marked":"npm.marked","ArticleAiSummaryDetail":"ArticleAiSummaryDetail","Documentdetail":"Documentdetail","Search":"Search","npm.clipboard":"npm.clipboard","SearchMedSeek":"SearchMedSeek","npm.qrcodejs2":"npm.qrcodejs2","my":"my","npm.xgplayer-hls.js":"npm.xgplayer-hls.js","npm.xgplayer":"npm.xgplayer","Livedetail":"Livedetail","tabber":"tabber"}[chunkId]||chunkId) + "." + {"Alldisease":"d9db451d","Choosetofocus":"57ef56fd","Collection":"eaba287f","ColumnDetail":"45ac9233","ColumnList":"f623b596","Connect":"acc7af79","Connect2":"c6ef4210","Detailsofdisease":"f84b54ca","Detdoctor":"091ff0d3","DrugDetail":"27025d14","Drugspeciespage":"bccd8890","Editdisease":"f55e37b4","Focus":"381e00b1","Getpersonalinfo":"37c0554d","Historicalrecord":"85b9e346","Home":"8b73c7fd","Letters":"063fb722","Livelist":"78ff5ca4","MedicineBook":"c4be8971","Modifydata":"3359691a","Nopage":"5e4f4eed","Organdetails":"590e2665","Patientgroups":"1ea47e88","Registered":"1e3dd470","Relatedtothedoctor":"75537484","Screeningofsearch":"1aa03f66","Searchdrug":"db1b4261","Searchlist":"fc2356b9","Tem":"6ad2e9ec","chunk-00127e18":"7c66a435","chunk-030d8c3a":"d07c5af3","chunk-17e8f758":"f1f6af78","chunk-2310fd30":"57ff0ef9","chunk-2374f440":"9b2a56e5","chunk-2a4da618":"5b803360","chunk-2d20fb77":"31d6cfe0","chunk-2d221c44":"31d6cfe0","chunk-2d5f0b0e":"62bed82a","chunk-2d9aa5c2":"a781eea2","chunk-36f69b42":"47557287","chunk-37f3931c":"889c46d5","chunk-49a19af8":"9da23cf1","chunk-523dc9f1":"5f56ba04","chunk-5381a0ee":"17c57123","chunk-5af20308":"ab77c75f","chunk-657a11f6":"03456369","chunk-69311384":"82a30896","chunk-6dcce11d":"80ae866d","chunk-6fa1884a":"6b86c291","chunk-76c1fcf5":"6e6d73ba","chunk-79a0dc60":"3b9f4409","chunk-7d5647b2":"18fdfcf0","chunk-8bf711ca":"fd01bafa","chunk-98e8dae0":"c3e74153","chunk-c656edce":"53a6763b","chunk-c8846038":"d46a8046","chunk-d58d70da":"f17ee22b","chunk-fa6970fe":"a63e85f3","npm.crypto-js":"31d6cfe0","npm.ali-oss":"31d6cfe0","npm.qiniu-js":"31d6cfe0","CompleteInfo":"8b7e9311","Userinfo":"4707afcd","chunk-282e9001":"088a1060","npm.marked":"31d6cfe0","ArticleAiSummaryDetail":"9a6e8d7e","chunk-341d270a":"fd4a6777","chunk-54e2d0d5":"7ee0a25a","Documentdetail":"3890d383","chunk-7a34045d":"167bdf7a","Search":"eabf08f6","npm.clipboard":"31d6cfe0","SearchMedSeek":"4bde6610","npm.qrcodejs2":"31d6cfe0","my":"46b4c10b","npm.xgplayer-hls.js":"31d6cfe0","npm.xgplayer":"31d6cfe0","chunk-0fe15411":"b34ca103","Livedetail":"7fdf4ea4","chunk-5c592e3c":"7171e7a7","tabber":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
